import PostsSerializer from './base';

export default class TagCategory extends PostsSerializer {}
